import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { favoriteService } from '../Services/FavoriteService';
import { fetchFolders } from './FolderSlice';
import { FavoriteDto } from '../types';

export const fetchFavorites = createAsyncThunk('favorites/fetchFavorites', async () => {
  return await favoriteService.getFavorites();
});

export const toggleFavorite = createAsyncThunk('favorites/toggleFavorite', async (documentId: string | number, { dispatch }) => {
  await favoriteService.toggleFavorite(documentId);
  dispatch(fetchFolders());
  return await favoriteService.getFavorites();
});

export const assignToFolder = createAsyncThunk('favorites/assignToFolder', async (payload: { documentId: string | number, folderId: string }, { dispatch }) => {
  await favoriteService.addToFolder(payload.documentId, payload.folderId);
  dispatch(fetchFolders());
  return await favoriteService.getFavorites();
});

export const removeFromFolder = createAsyncThunk('favorites/removeFromFolder', async (payload: { documentId: string | number, folderId: string }, { dispatch }) => {
  await favoriteService.removeFromFolder(payload.documentId, payload.folderId);
  dispatch(fetchFolders());
  return await favoriteService.getFavorites();
});

interface FavoriteState {
  items: FavoriteDto[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: FavoriteState = {
  items: [],
  status: 'idle',
};

const favoriteSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFavorites.fulfilled, (state, action) => {
      state.items = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(toggleFavorite.fulfilled, (state, action) => {
      state.items = action.payload;
    });
    builder.addCase(assignToFolder.fulfilled, (state, action) => {
      state.items = action.payload;
    });
    builder.addCase(removeFromFolder.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  }
});
export default favoriteSlice.reducer;
